import React from 'react';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
} from '../../../../../shared/lib/toggleModalVisble';
import IconBtn from '../../../../../shared/ui/IconBtn/IconBtn';

const ShowHistory = ({ shutdown }) => {
  const dispatch = useModalDispatch();

  const handleClick = () => {
    dispatch({
      type: modalActionTypes.setModalData,
      payload: {
        type: modalTypes.shutdownHistory,
        initialValues: shutdown,
      },
    });
  };

  return (
    <IconBtn
      tooltipTitle="История"
      onClick={handleClick}
      icon="history"
    />
  );
};

export default ShowHistory;
